import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHelp } from '../contexts/HelpContext';

export default function HelpPopover() {
  const { isHelpMode, toggleHelpMode } = useHelp();

  const handleClick = () => {
    toggleHelpMode();
  };



  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          color: isHelpMode ? 'white' : 'text.secondary',
          backgroundColor: isHelpMode ? '#FF9800' : 'transparent',
          borderRadius: isHelpMode ? '8px' : '4px',
          '&:hover': {
            color: isHelpMode ? 'white' : 'primary.main',
            backgroundColor: isHelpMode ? '#F57C00' : 'action.hover'
          }
        }}
      >
        <HelpOutlineIcon />
      </IconButton>
      

    </>
  );
} 